import { observer } from 'mobx-react-lite'
import { providerLogo, formatNumber } from '../../../../../../utils/Helper'
import React from 'react'
import DropdownButton from '../../../../../FormComponents/DropdownButton'

export default observer(function InfluencerHeader({ influencer, campaignScenario, dropdownOpen, setDropdownOpen }) {
  const hasActions = campaignScenario.actions.some(action => action.influencer_id === influencer.id)
  const getProviderColor = provider => ({
    instagram: 'text-pink-600',
    tiktok: '',
    youtube: 'text-red-500'
  }[provider])

  return (
    <div key={influencer.id} className="p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <img className="h-12 w-12 rounded-full" src={influencer.authentications?.[0]?.avatar} alt=""/>
          <div className="ml-4">
            <p className="font-bold mb-1 dark:text-white">{influencer.full_name}</p>
            <div className="flex items-center gap-4">
              { influencer.authentications?.map(authentication =>
                <div key={authentication.id} className="flex items-center gap-2 border-1 border-border-primary dark:border-rb-dark-mode-lighter rounded-lg py-1 px-2">
                  <div className={`${getProviderColor(authentication.provider)}`}>{providerLogo(authentication.provider)}</div>
                  <p className="text-sm dark:text-white">{formatNumber(authentication.reach)}</p>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex">
          {hasActions && <DropdownButton dropdownOpen={dropdownOpen} setDropdownOpen={setDropdownOpen} className="ml-3 dark:text-white" />}
        </div>
      </div>
    </div>
  )
})